import { Environment } from '@abp/ng.core';

const baseUrl = 'https://reportiz.sudocad.com';

const oAuthConfig = {
  issuer: 'https://api-reportiz.sudocad.com/',
  clientId: 'Io_App',
  scope: 'offline_access Io',
  requireHttps: true,
};

export const environment = {
  production: true,
  application: {
    baseUrl,
    name: 'Reportiz - Test',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://api-reportiz.sudocad.com',
      rootNamespace: 'Sudocad.Io',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  aiService: {
    url: 'https://api-reportiz.sudocad.com',
  },
} as Environment;